import { createSelector } from 'reselect'
import Fetch from '../constants/fetch-forgotpwd'
import RequestPhoneCodes from '../constants/request-phone-codes'
import RequestRecaptcha from '../constants/request-recpatcha'
import RequestSubmits from '../constants/request-submit'
import resendMessage from '../constants/resend-message'


import {

    FETCH_DATA_ERROR,
    FETCH_DATA_SUCCESS,
    INIT,
    SESSION_TIMEOUT,
    REQUEST_PHONE_CODES,
    REQUEST_PHONE_CODES_SUCCESS,
    REQUEST_PHONE_CODES_ERROR,
    REQUEST_RECAPTCHA,
    REQUEST_RECAPTCHA_SUCCESS,
    REQUEST_RECAPTCHA_ERROR,
    SUBMIT_REQUEST,
    SUBMIT_REQUEST_SUCCESS,
    SUBMIT_REQUEST_ERROR,
} from '../constants/analytics-register'


export const initialState = {
    activeSession: false,
    data: {},
    error: null,
    resendSuccessMsg: resendMessage.DEFAULT,
    sessionTimeout: false,
    status: Fetch.PENDING,
    step: 0
}

// Selectors
const selectRequestData = state => state.analyticsRegister

const selectStateFor = key => createSelector(
    selectRequestData,
    (request = {}) => request[key]
)

export const selectErrorMessage = selectStateFor('error')
export const selectPhoneCodes = selectStateFor('phoneCodes')
export const selectRecaptcha = selectStateFor('recaptchaValue')
export const selectStep = selectStateFor('step')
export const selectQuickRegister = selectStateFor('submitRequest')

export default function analyticsRegister(state = initialState, action) {
    switch (action.type) {

        case FETCH_DATA_ERROR:
            return {
                ...state,
                activeSession: false,
                data: {},
                error: action.payload,
                status: Fetch.ERROR
            }
        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                activeSession: true,
                data: { ...action.payload },
                error: null,
                status: Fetch.SUCCESS,
                step: 1
            }
        case INIT:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                status: Fetch.PENDING
            }

        case REQUEST_PHONE_CODES:
            return {
                ...state,
                error: null,
                status: RequestPhoneCodes.PENDING
            }

        case REQUEST_PHONE_CODES_ERROR:
            return {
                ...state,
                error: action.payload,
                status: REQUEST_PHONE_CODES_ERROR.ERROR
            }

        case REQUEST_PHONE_CODES_SUCCESS:
            return {
                ...state,
                error: null,
                phoneCodes: [ ...action.payload ],
                status: REQUEST_PHONE_CODES_SUCCESS.SUCCESS
            }
        case REQUEST_RECAPTCHA:
            return {
                ...state,
                error: null,
                status: RequestRecaptcha.PENDING
            }

        case REQUEST_RECAPTCHA_ERROR:
            return {
                ...state,
                error: action.payload,
                status: RequestRecaptcha.ERROR
            }

        case REQUEST_RECAPTCHA_SUCCESS:
            return {
                ...state,
                error: null,
                recaptchaValue: { ...action.payload },
                status: RequestRecaptcha.SUCCESS
            }

        case SUBMIT_REQUEST:
            return {
                ...state,
                error: null,
                submitStatus: RequestSubmits.PENDING
            }
        case SUBMIT_REQUEST_ERROR:
            return {
                ...state,
                error: action.payload,
                submitStatus: RequestSubmits.ERROR
            }
        case SUBMIT_REQUEST_SUCCESS:
            return {
                ...state,
                data: { ...action.payload },
                step: state.step + 1,
                submitStatus: RequestSubmits.SUCCESS,
            }

        case SESSION_TIMEOUT: {
            return {
                ...state,
                sessionTimeout: true
            }
        }
        default:
            return state

    }
}
